<template>
  <div>

    <Head style="background-color: #cbb486" />
    <div class="background-index"></div>
    <BreadCrumbs />
    <Content />
    <Footer />
  </div>
</template>

  <script>
import BreadCrumbs from '@/components/home/breadCrumbs'
import Content from './siderContent-01'
import Head from "@/components/index/head"
import Footer from "@/components/index/footer"
export default {
  name: 'player',
  components: {
    BreadCrumbs,
    Content,
    Head,
    Footer
  },
  created () {
    window.scrollTo(0, 0)
  }
}
  </script>

<style scoped lang='less'>
.background-index {
  height: 190px;
  width: 100%;
  /* position: absolute; */
  /* index: -1; */
  background-image: url("../../../assets/images/icon_window_service_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/player/index.vue